import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import { MdDirectionsCar, MdModeOfTravel, MdAvTimer, MdColorLens, MdOutlineMoney, MdPerson, MdShare, MdGpsFixed, MdAcUnit, MdFlashOn, MdPanoramaWideAngle, MdCameraRear, MdCarRepair, MdSettingsInputComponent, MdAirlineSeatReclineExtra, MdEngineering, MdOutlineAirlineSeatReclineNormal, MdOutlineCameraRear, MdLocationOn } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_PROPERTY_SUCCESS, FETCH_VEHICLE_SUCCESS } from '../../../app/actions/actions';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../config/routingUrl';
import { RiEye2Fill } from 'react-icons/ri';
import { Vector_Design, emptyImage } from '../../../utils/dataApi/dataFormApi';
import { FaHorseHead, FaMapLocationDot } from 'react-icons/fa6';
import { FaArrowAltCircleLeft, FaChargingStation, FaMapMarkedAlt, FaSun, FaTachometerAlt } from 'react-icons/fa';
import { IoSpeedometerOutline } from 'react-icons/io5';
import { TbManualGearbox } from 'react-icons/tb';
import { BsCalendar } from "react-icons/bs";
import { SiTurbosquid } from "react-icons/si";
import MapContainerModal from '../../admin/reservations/maps/MapModal';
import ShareComponentModal from '../../admin/reservations/maps/ShareModal';


const VehicleDetails = ({ vehicle }) => {

  const navigate = useNavigate();

  const paramVehcile = useParams();

  const dispatch = useDispatch();
  // 🔗 Générer le lien de partage
  const shareUrl = window.location.href;

  // const vehicles = useSelector((state) => state.vehicles.vehicles)

  // useEffect(() => {
  //     console.log(paramVehcile?.id);
  //     const objetTrouve = vehicles && [...vehicles].length > 0 ? [...vehicles].find(objet => objet._id === paramVehcile?.id) : vehicle ;
  //     dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: objetTrouve });
  // }, [paramVehcile]);


  const images = vehicle && vehicle.images && vehicle.images.length > 0 ? vehicle.images.map((image) => ({
    original: image,
    thumbnail: image
  })) : [{
    original: emptyImage,
    thumbnail: emptyImage
  }];


  const [showModal, setShowModal] = useState(false);

  // Exemple de données pour l'élément à afficher
  const elementData = {
    address: "123 Rue de l'Exemple, Alger",
    lat: vehicle?.lat, // Latitude d'exemple
    lng: vehicle?.lng,  // Longitude d'exemple
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const [showModalShare, setShowModalShare] = useState(false);



  const handleShowModalShare = () => setShowModalShare(true);
  const handleCloseModalShare = () => setShowModalShare(false);


  const textStyleElement = {
    
    display: '-webkit-box',
    WebkitLineClamp: 1, // Limite à 3 lignes
    maxWidth: "80px",
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <section className="container-fluid" style={{ padding: "100px 0px 0px 0px", background: "#F5FDF7" }}>
      <div className="container" style={{ position: "relative", zIndex: 65 }}>
        <div className="pb-5">
          <div>
            <Button className="" onClick={() => { navigate(-1) }} variant="dark" style={{ borderRadius: "20px", padding: "10px 10px 10px 10px" }}>
              <span className="bg-white rounded-lg"><FaArrowAltCircleLeft color={"#42B711"} size={30} /></span>  <span className="px-3"> Retour </span></Button>
          </div>
        </div>
        <div className="row">
          <Col md={6}>
            <div className="" style={{ height: '100%', }}>
              <div>
                {/* Galerie d'images */}
                <ImageGallery
                  items={images}
                  showThumbnails={true}
                  showFullscreenButton={false}

                  showPlayButton={false}
                  renderItem={(item) => (
                    <img
                      src={item.original}
                      alt=""
                      className="img-fluid rounded-lg"
                      style={{
                        height: '350px',
                        width: '100%',
                        objectFit: 'fill',
                        overflow: 'hidden',
                        borderRadius: "15px", // Coins arrondis pour l'image
                      }}
                    />
                  )}

                />
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className=" rounded-5  m-b40 m-sm-b0">
              <div className="">
                <div>
                  <div className="dlab-post-title">
                    <h3 className="post-title">
                      <Link to="javascript:void(0);" style={{ fontSize: "32px", color: "black" }}>{vehicle?.brand}</Link>
                    </h3>
                    {/*<h6 className="sub-title">{vehicle?.type?.name || ""}</h6> */}
                    <div style={{ display: "flex", alignContent: "center" }}>
                      <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="font-bold"> {vehicle.basePricePerDay || 0} </span>
                      <span style={{ fontWeight: "bold", color: "black", fontSize: "32px" }} className="px-1"> DZD </span>
                      <span style={{ color: "#A6A6A6", fontSize: "20px", textAlign: "end" }} className="px-1 pt-2"> /Jour</span>
                    </div>
                  </div>

                  {/* ✅ Caractéristiques du véhicule */}



                  {// vehicle
                    vehicle?.brand && (vehicle?.mileage || vehicle?.options?.automaticTransmission || vehicle?.passenger || vehicle?.engineType?.name) && (
                      <div className="row">
                        <div style={{ padding: "2px 5px 2px 5px", display: "flex", justifyItems: "center", background: "white" }} className="col-md-12 bg-white my-3 my-2 rounded-lg">
                          {vehicle?.mileage && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <IoSpeedometerOutline className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">{vehicle?.mileage || 0}</span>
                            </div>
                          )}

                          {/* Transmission */}
                          {(vehicle?.options?.automaticTransmission || vehicle?.options?.manualTransmission) && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <TbManualGearbox className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">
                                {vehicle?.options?.automaticTransmission ? "Auto" : vehicle?.options?.manualTransmission ? "Manuelle" : ""}
                              </span>
                            </div>
                          )}

                          {/* Sièges */}
                          {vehicle?.passenger && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <MdOutlineAirlineSeatReclineNormal className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">{vehicle?.passenger || 4}</span>
                            </div>
                          )}

                          {/* Moteur */}
                          {vehicle?.engineType?.name && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <FaChargingStation className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">{vehicle?.engineType?.name || ""}</span>
                            </div>
                          )}


                        </div>
                      </div>
                    )
                  }

                  {// vehicle
                    (vehicle?.color || vehicle?.year) && (
                      <div className="row">
                        <div style={{ padding: "2px 5px 2px 5px", display: "flex", justifyItems: "center", background: "white" }} className="bg-white my-2 rounded-lg">

                          {/* Couleur */}
                          {vehicle?.color && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <MdColorLens className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">{vehicle?.color || ""}</span>
                            </div>
                          )}

                          {/* Année */}
                          {vehicle?.year && (
                            <div
                              className=" bg-white p-1 m-1 d-flex flex-column align-items-center justify-content-center"
                              style={{ width: "120px" }}
                            >
                              <BsCalendar className="text-dark mb-1" size={25} />
                              <span className="text-center text-dark text-sm">{vehicle?.year || ""}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  }


                </div>
              </div>
            </div>
          </Col>
          {/*options supplementaires */}
        </div>
      </div>






      <div className="container-fluid " style={{ position: "relative", zIndex: 60, top: -150, background: "linear-gradient(90deg, #43B613, #1D5008)", padding: "100px 10px 100px 10px" }}>
        <div className="container bg-transparent" style={{ position: "relative", zIndex: 70 }}>
          <div className="row">
            <Col md={6}>
              <div className="col-md-6">
                <div>
                  <h4 className="text-white"> Description </h4>

                  <p className="pt-5 text-white">
                    {
                      vehicle?.description || ""
                    }
                  </p>

                </div>
              </div>

            </Col>

            {/* ✅ Section Prix & Réservation */}
            <Col md={6}>
              <div className="m-b40 m-lg-b30">
                {
                  // options supplementaire sur vehicule
                  (vehicle?.options?.gps ||
                    vehicle?.options?.turbo ||
                    vehicle?.options?.sunroof ||
                    vehicle?.options?.reverseCamera ||
                    vehicle?.options?.speedRegulator ||
                    vehicle?.options?.horsepower ||
                    vehicle?.interiorType?.name) && (
                    <div
                      style={{
                        padding: "5px",
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center", // Centre les éléments verticalement
                      }}
                      className="my-3 rounded-lg"
                    >
                      {/* GPS */}
                      {vehicle?.options?.gps && (
                        <div
                          className="rounded-lg p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <FaMapMarkedAlt className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement}>GPS</span>
                        </div>
                      )}

                      {/* Turbo */}
                      {vehicle?.options?.turbo && (
                        <div
                          className="rounded-lg p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <SiTurbosquid className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement}>Turbo</span>
                        </div>
                      )}

                      {/* Toit ouvrant */}
                      {vehicle?.options?.sunroof && (
                        <div
                          className="rounded-lg p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <FaSun className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement}>Toit ouvrant</span>
                        </div>
                      )}

                      {/* Caméra de recul */}
                      {vehicle?.options?.reverseCamera && (
                        <div
                          className="rounded-lg p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <MdOutlineCameraRear className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement}>Caméra de recul</span>
                        </div>
                      )}

                      {/* Régulateur de vitesse */}
                      {vehicle?.options?.speedRegulator && (
                        <div
                          className="rounded-lg p-2 m-1 border-white border d-flex flex-column align-items-center justify-content-center"
                          style={{ width: "120px", backgroundColor: "#55913d" }}
                        >
                          <FaTachometerAlt className="text-white mb-1" size={25} />
                          <span className="text-center text-white text-truncate" style={textStyleElement}>Régulateur de vitesse</span>
                        </div>
                      )}
                    </div>
                  )
                }





              </div>



            </Col>


            <Col md={12} >
              <div className="row">
                <div className="col-md-12">
                  <div className="" style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                    <div></div>
                    <div className="" style={{ width: "100%", display: "flex", justifyContent: "end", paddingRight: "100px" }}>
                      <div>
                        <button
                          type="button" variant="white"
                          className="btn btn-white text-dark rounded-lg mx-2" style={{ padding: "10px 20px 10px 20px", fontSize: "30px", borderRadius: "100px" }}
                          onClick={() => {
                            dispatch({ type: FETCH_VEHICLE_SUCCESS, payload: vehicle });
                            dispatch({ type: FETCH_PROPERTY_SUCCESS, payload: {} });
                            navigate(`/${ROUTES.RESERVATION_FORM_PAGE_WEB}`, { state: vehicle });
                          }}
                        >
                          Réserver
                        </button>
                      </div>
                      <div>
                        <button
                          type="button" variant="white"
                          className="btn btn-white rounded-lg mx-2" style={{ padding: "10px 20px 10px 20px", fontSize: "30px", borderRadius: "100px" }}
                          onClick={handleShowModalShare}
                        >
                          <MdShare className="text-dark" size={40} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>


          </div>
        </div>

        <div style={{ position: "absolute", right: "1%", bottom: -30, zIndex: 60 }}>
          <img src={Vector_Design} />
        </div>
      </div>


      {/* Modal avec la carte */}
      <MapContainerModal
        show={showModal}
        onHide={handleCloseModal}
        address={vehicle.address}
        lat={vehicle.lat}
        lng={vehicle.lng}
      />
      {/*Modal share */}
      <ShareComponentModal show={showModalShare} onHide={handleCloseModalShare} shareUrl={shareUrl} />

    </section>
  );
};

export default VehicleDetails;
